import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_93cd8267-7880-40ff-a065-9d7923e16a65/artifacts/6b7x03b7_6B6D6A70-FD2B-4541-BE37-F1C006A13B72.png";

export const IMAGES = {
  heroVideo: "https://assets.mixkit.co/videos/9678/9678-720.mp4",
  heroVideoAlt: "https://assets.mixkit.co/videos/52454/52454-720.mp4",
  heroTruck: "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  sunsetTruck: "https://images.unsplash.com/photo-1651928977880-ffb2d963b6b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  nightSemi: "https://images.unsplash.com/photo-1562954203-74c7fb884cba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blueSkySemi: "https://images.pexels.com/photos/28264496/pexels-photo-28264496.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  fleetAerial: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  flatbed: "https://images.unsplash.com/photo-1501700493788-fa1a4fc9fe62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  redSemi: "https://images.unsplash.com/photo-1586191552066-d52dd1e3af86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  boxTruck: "https://images.unsplash.com/photo-1601467995997-ac1ae9a8fff4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dispatchOffice: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  dispatchMan: "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  founder: "https://customer-assets-lxgj4vgw.emergentagent.net/job_next-mile-build/artifacts/gt4dupei_D7B1CD99-26C1-49B9-84AB-9A0E0AF463F0.png",
  parkedFleet: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
